import { createAction } from 'redux-actions';
import * as ActionTypes from '../actionTypes/credentials';

export const getCredentialList = createAction(ActionTypes.GET_CREDENTIAL_LIST);
export const setBulkAddDetails = createAction(ActionTypes.SET_BULK_ADD_DETAILS);
export const clearCredentialList = createAction(ActionTypes.CLEAR_CREDENTIAL_LIST);

